module.exports = __webpack_public_path__ + "static/img/aAPLE.4115141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aAPLE.png
// module id = X2Pt
// module chunks = 1